/** 色パレット */
type Palette = {
  front: string;
  top: string;
  dark: string;
};
const PaletteDef: Palette[] = [
  { front: "#4e8ef7", top: "#82b4ff", dark: "#1e4fcc" },
  { front: "#f7844e", top: "#ffb482", dark: "#c04820" },
  { front: "#4ec87f", top: "#82ffc1", dark: "#1e9050" },
  { front: "#b44ef7", top: "#d882ff", dark: "#7020c0" },
  { front: "#f74e8e", top: "#ff82b4", dark: "#c01858" },
  { front: "#4ef7e8", top: "#82fff4", dark: "#10a098" },
  { front: "#8ef74e", top: "#b4ff82", dark: "#50c010" },
  { front: "#f7d34e", top: "#fff082", dark: "#c09010" },
];

export const getPalette = (index: number) => {
  return PaletteDef[Math.abs(index) % PaletteDef.length];
};
